import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Grid,
  Zoom,
} from "@material-ui/core";
import { useSelector } from "react-redux";

export default function DialogLogin() {
  const auth = useSelector((state) => state.auth);
  return (
    <Dialog
      open={true}
      onClose={null}
      maxWidth="lg"
      fullWidth
      aria-labelledby="responsive-dialog-title"
      scroll={"body"}
      PaperProps={{
        style: {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <DialogContent>
        <Zoom in={true}>
          <Grid container spacing={2} justify="center">
            <Grid item xs={12} sm={8} md={4} align="center">
              <img
                src={process.env.REACT_APP_LOGO_WEB}
                alt="logo"
                style={{ width: "50%" }}
              />
            </Grid>
            <Grid item xs={12} />
            <Grid item xs={12} sm={8}>
              <Typography
                variant="h4"
                align="center"
                style={{ color: "white" }}
              >
                Bienvenid@ {auth.firstname}
              </Typography>
            </Grid>
          </Grid>
        </Zoom>
      </DialogContent>
    </Dialog>
  );
}
